// extracted by mini-css-extract-plugin
export var wrap = "request-demo-form-module--wrap--1wUk2";
export var leftIllustr = "request-demo-form-module--leftIllustr--96wJi";
export var rightIllustr = "request-demo-form-module--rightIllustr--2BQCe";
export var illustr = "request-demo-form-module--illustr--2EZ9F";